<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">mail</mat-icon>
    EMAIL DOCUMENT
  </div>
  <button type="button" aria-label="Close" (click)="onCancel()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <form (ngSubmit)="onSubmit()" #emailForm="ngForm" class="email-form">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>To</mat-label>
      <input matInput type="email" name="to" [(ngModel)]="email.to" required />
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Message</mat-label>
      <textarea matInput name="message" [(ngModel)]="email.message" rows="5">
        Please see attached invoice copy for your records
      </textarea>
    </mat-form-field>
    <mat-dialog-actions align="end">
      <button mat-flat-button class="submit" type="submit" [disabled]="!emailForm.form.valid">Send</button>
      <button mat-button class="reset" (click)="onCancel()">Cancel</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>